<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des trésoreries</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddCompteEntreprise')">
        <a class="btn btn-primary" href="#" data-bs-toggle="modal" data-bs-target="#AddCompteEntrepriseModal">
          <i class="fa fa-plus-circle"></i>
          Ajouter une trésorerie
        </a>
      </div>
      <div class="col-md-4" v-if="point_ventes.length > 1">
    <div class="form-group mb-15 mb-sm-20 mb-md-25">
      <label class="d-block text-black fw-semibold mb-10">
       Filtrer par Point de vente
      </label>
      <div class="d-flex align-items-center" style="width: 200px;">
        <Multiselect 
          v-model="point_vente" 
          :options="point_ventes"  
          :searchable="true" 
          track-by="label" 
          label="label" 
          placeholder="Sélectionner un point de vente" 
        />
      </div>
    </div>
  </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher" class="form-control shadow-none text-black"
            placeholder="Rechercher un compteEntreprise" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>

      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                INTITULE
              </th>
              <!--<th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                SOLDE INITIAL
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                SOLDE ACTUEL
              </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type de Compte
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Numéro de Compte
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(compteEntreprise, index) in compteEntreprises" :key="index">

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ compteEntreprise.intituleCompteEnt }}
              </td>
              <!--<td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(compteEntreprise.soldeInitialCompteEnt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(compteEntreprise.soldeActuelCompteEnt) }}
              </td>-->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ compteEntreprise.typeCompte }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-if="compteEntreprise.typeCompte == 'Compte Bancaire'">
                  {{ compteEntreprise.numeroCompteEnt }}
                </span>
                <span v-else="compteEntreprise.typeCompte == 'Compte Mobile Money'">
                  {{ compteEntreprise.telephoneMoMo }}
                </span>

              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">Actions</button>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('EditCompteEntreprise')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        data-bs-toggle="modal" data-bs-target="#AddCompteEntrepriseModal"
                        @click="moddifier(compteEntreprise)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>

                    <!-- <li>
                        <router-link :to="{ name: 'ViewCompteEntreprisePage', params: { id: compteEntreprise.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                        </router-link>
                    </li> -->
                    <li v-if="checkPermission('DeleteCompteEntreprise')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(compteEntreprise.id, compteEntreprises, 'comptes-entreprise', `la trésorerie ${compteEntreprise.intituleCompteEnt}`)">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddCompteEntrepriseModal :item="selectedItem" @close="recharger" />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { CompteEntreprise } from "@/models/CompteEntreprise";
import ApiService from "@/services/ApiService";
import { suppression, error, separateur } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import AddCompteEntrepriseModal from "./AddCompteEntrepriseModal.vue";
import Multiselect from "@vueform/multiselect";
export default defineComponent({
  name: "ListeCompteEntreprise",
  components: {
    PaginationComponent,
    AddCompteEntrepriseModal,
    Multiselect,
  },
  setup() {

    onMounted(async () => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllCompteEntreprises(point_vente.value);
    });

    const compteEntreprises = ref<Array<CompteEntreprise>>([]);
    const compteEntreprise = ref<CompteEntreprise>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const selectedItem = ref(0);

    let point_vente = ref<string>("");
    let point_ventes = ref([]);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllCompteEntreprises(page_, limit_);
      } catch (error) {
        //
      }
    };

    watch(point_vente, () => {
      rechercher();
    });


    function rechercher() {
      getAllCompteEntreprises(point_vente.value,page.value, limit.value, searchTerm.value);
    }

    const recharger = () => {
      getAllCompteEntreprises(point_vente.value);
    };

    // END PAGINATE

    function getAllCompteEntreprises(point_vent,page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/comptes-entreprise?page=${page}&limit=${limi}&mot=${searchTerm}&pointvente=${point_vent}&`)
        .then(({ data }) => {
          compteEntreprises.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    function moddifier(EditcompteEntreprises: CompteEntreprise) {
      compteEntreprise.value = EditcompteEntreprises;
      selectedItem.value = EditcompteEntreprises.id;
    }

    const deleteCompteEntreprise = (id: number) => {
      ApiService.delete(`/comptes-entreprise/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < compteEntreprises.value.length; i++) {
        if (compteEntreprises.value[i].id === id) {
          compteEntreprises.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return {
      compteEntreprises,
      checkPermission,
      getAllCompteEntreprises,
      deleteCompteEntreprise,
      moddifier,
      suppression,
      separateur,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      selectedItem,
      recharger,
      searchTerm,
      point_ventes,
      point_vente
    };
  },
});
</script>